package com.anjuros.website.redesign.sections.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun BlogClosingSection() {
    RdClosingCard(
        RdText.BLOG_CLOSE_EYEBROW, RdText.BLOG_CLOSE_TITLE, RdText.BLOG_CLOSE_LEDE,
        secondaryText = RdText.BLOG_CLOSE_DESIGNS, secondaryPath = RdRoute.DESIGNS,
    )
}
